import actions from "actions";
import ActionTypes from "actions/ActionTypes";
import { SiteStatistic } from "Models/site";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { createLoadingSelector } from "reducers/selectors";
import { bindActionCreators, Dispatch } from "redux";
import "../styles/sidebar.scss";
import { SideBarSiteManagerProps } from "../type";
import SidebarItem from "./SidebarItem";
import { useHistory, useLocation } from "react-router-dom";

const loadingSelector = createLoadingSelector([
  ActionTypes.SITE_STATISTIC_PREFIX,
]);

const initialStatistic: any = 0;

const SideBarSiteManager = ({
  getSiteStatistic,
  siteStatistic = [],
  loading,
}: SideBarSiteManagerProps) => {
  const history = useHistory();
  const location = useLocation();
  const [currentStatistic, setCurrentStatistic] = useState(initialStatistic);
  useEffect(() => {
    getSiteStatistic && getSiteStatistic();
  }, []);
  useEffect(() => {
    setCurrentStatistic(location.search.split("=")?.[1]);
  }, [location]);
  const renderStatisticItem = (item: SiteStatistic) => {
    const handleClick = () => {
      history.push(`/sitev2?statistic=${item.id}`);
    };
    return (
      <SidebarItem
        isSelected={currentStatistic == item.id}
        key={item.id}
        item={item}
        onClick={handleClick}
      />
    );
  };
  return (
    <div className="side-bar-site">
      {siteStatistic?.map(renderStatisticItem)}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    loading: loadingSelector(state),
    siteStatistic: state.site.siteStatistic,
  };
};

const mapActionsToProps = (dispatch: Dispatch) =>
  bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapActionsToProps)(SideBarSiteManager);
